import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const ThankYouModal = ({ open, onClose, onGoHome }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    p: 2
                }
            }}
        >
            <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                    <CheckCircleIcon
                        sx={{
                            fontSize: 60,
                            color: 'success.main',
                            mb: 1
                        }}
                    />
                    <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold', color: 'grey.800' }}>
                        Dziękujemy!
                    </Typography>
                </Box>
            </DialogTitle>

            <DialogContent sx={{ textAlign: 'center', py: 3 }}>
                <Typography variant="h6" sx={{ mb: 2, color: 'grey.700' }}>
                    Bardzo dziękujemy za wypełnienie ankiety końcowej!
                </Typography>
                <Typography variant="body1" sx={{ color: 'grey.600', lineHeight: 1.6 }}>
                    Twoje odpowiedzi są dla nas bardzo cenne i pomogą nam w dalszym rozwoju aplikacji.
                    Dzięki Twojej opinii możemy tworzyć jeszcze lepsze narzędzia wspierające rozwój osobisty.
                </Typography>
                <Typography variant="body1" sx={{ color: 'primary.main', lineHeight: 1.6, mt: 2, fontWeight: 'bold' }}>
                    Możesz teraz pobrać swój Pakiet Mocy!
                </Typography>
            </DialogContent>

            <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
                <Button
                    variant="contained"
                    onClick={onGoHome}
                    size="large"
                    sx={{
                        background: 'linear-gradient(90deg, #c79a5f, #9b7b5e)',
                        px: 4,
                        py: 1.5,
                        borderRadius: 2,
                        fontWeight: 'bold',
                        '&:hover': {
                            background: 'linear-gradient(90deg, #c79a5f, #9b7b5e)',
                            transform: 'scale(1.05)'
                        }
                    }}
                >
                    Pobierz Pakiet Mocy
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ThankYouModal;
